import React from "react";
import { Button } from "../../../common/Button/Button";
import Checkbox from "../../../common/Checkbox/Checkbox";
import ReactTable from "react-table";
import moment from "moment";
import "react-table/react-table.css";
import find from "lodash/find";
import { getServiceTypesMaster } from "../../../utils/localStorage";

export default function AdminServiceRequestTable(props) {
	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};
	const columns = [
		{
			id: "checkbox",
			accessor: "",
			Header: (header) => {
				return (
					<Checkbox
						id={`checkbox-id-header`}
						checked={props.selectedServiceRequests.length === 10}
						onChange={() => {
							const updated = props.selectedServiceRequests.toggleAll(
								header.data,
								"_original"
							);
							props.onSelectServiceRequest(updated);
						}}
					/>
				);
			},
			Cell: ({ original }) => {
				return (
					<Checkbox
						id={`checkbox-id-${original.nResourceInstanceId}`}
						onChange={() => {
							const updated = props.selectedServiceRequests.addOrUpdate(
								original,
								"nResourceInstanceId"
							);
							props.onSelectServiceRequest(updated);
						}}
						checked={
							find(props.selectedServiceRequests, {
								nResourceInstanceId:
									original.nResourceInstanceId,
							}) !== undefined
						}
					/>
				);
			},
			width: 45,
			sortable: false,
			resizable: false,
			// show: false
		},
		{
			id: "sServiceCode",
			Header: "Service Name",
			accessor: "sServiceCode",
			width: 170,
			Cell: ({ original }) => {
				return <span>{getServiceName(original)}</span>;
			},
		},
		{
			id: "nResourceInstanceId",
			Header: "Instance Id",
			accessor: "nResourceInstanceId",
			width: 100,
		},
		{
			id: "sPackageOfferTitle",
			Header: "Package/Offering Title",
			accessor: "sPackageOfferTitle",
			width: 150,
			Cell: ({ original }) => (
				<span>
					{original.sPackageOfferTitle ? 
					(
						original.sPackageOfferTitle
					) : 
					(
						""
					)}
				</span>
			),
		},
		{
			id: "nPackageInstanceId",
			Header: "Package/Offering Instance Id",
			accessor: "nPackageInstanceId",
			width: 100,
		},
		{
			id: "refHH",
			Header: "Handholder",
			accessor: "refHH",
			width: 250,
			Cell: ({ original }) => {
				return (
					<>
						<span>{original["refHH"]}</span>
					</>
				);
			},
		},
		{
			id: "existing_service_facilitator",
			Header: "Recent Service Facilitator",
			accessor: "existing_service_facilitator",
			width: 250,
			Cell: ({ original }) => {
				return original["existing_service_facilitator"] ? (
					<span>
						{original["existing_service_facilitator"]["email"]}
					</span>
				) : (
					<span></span>
				);
			},
		},
		{
			id: "existing_service_facilitator",
			Header: "Facilitator Status",
			accessor: "existing_service_facilitator",
			width: 100,
			Cell: ({ original }) => {
				return original["existing_service_facilitator"] ? (
					<span>
						{original["existing_service_facilitator"]["is_active"]
							? original["existing_service_facilitator"][
									"out_of_office"
							  ]
								? "Out of Office"
								: "Active"
							: "Deactivated"}
					</span>
				) : (
					<span></span>
				);
			},
		},
		{
			id: "sEmailAddress",
			Header: "Customer Email",
			accessor: "sEmailAddress",
		},
		{
			id: "sContactNumber",
			Header: "Customer Contact",
			accessor: "sContactNumber",
			// width: 130,
		},
		{
			id: "refExternalServicePartner",
			Header: "External Service Partner",
			accessor: "refExternalServicePartner",
			Cell: ({ original }) => {
				return original["refExternalServicePartner"] ? (
					<span>
						{original["refExternalServicePartner"]}{original["ext_sp_org"]? (" ("+original["ext_sp_org"]+")"): ""}
					</span>
				) : (
					<span></span>
				);
			},
			// width: 130,
		},
		{
			id: "dtRequested",
			Header: "Created On",
			accessor: "dtRequested",
			width: 100,
			Cell: ({ original }) =>
				moment(original.dtRequested).format("DD/MM/YYYY"),
		},
		{
			id: "dtFollowupOn",
			Header: "Follow Up",
			accessor: "dtFollowupOn",
			width: 100,
			Cell: ({ original }) =>
				moment(original.dtFollowupOn).format("DD/MM/YYYY"),
		}, //sPaymentStatus
		{
			id: "sPaymentStatus",
			Header: "Payment Status",
			accessor: "sPaymentStatus",
			width: 125,
			Cell: ({ original }) =>
				original.sPaymentStatus ? original.sPaymentStatus : "N/A",
		},
		{
			id: "bUserInSPM",
			Header: "User in SPM",
			accessor: "bUserInSPM",
			Cell: ({ original }) => (original.bUserInSPM ? "Yes" : "No"),
		},

		{
			id: "refSRState",
			Header: "Current State",
			accessor: "refSRState",
			Cell: ({ original }) =>
				original.refSRState === "Cancelled" ? (
					original.sSRCancellationReason === "Other" ? (
						<span>
							{original.refSRState} {"-"}
							{original.sSRCancellationReasonOtherDescription}
						</span>
					) : (
						<span>
							{original.refSRState} {"-"}
							{original.sSRCancellationReason}
						</span>
					)
				) : (
					<span>{original.refSRState}</span>
				),
		},
		{
			id: "bMovedToSPM",
			Header: "Moved To SPM",
			accessor: "bMovedToSPM",
			Cell: ({ original }) => (original.bMovedToSPM ? "Yes" : "No"),
		},

		{
			id: "sBusinessPincode",
			Header: "Pincode",
			accessor: "sBusinessPincode",
			Cell: ({ original }) => (
				<span>
					{original.sBusinessPincode ? (
						<>
							<span title={`${original.sBusinessCity ?original.sBusinessCity:""}${" "}${original.sBusinessState ?original.sBusinessState:""}`}>{original.sBusinessPincode}</span>
						</>
					) : (
						""
					)}
				</span>
			),
		},

		{
			id: "bStayEngagedWithEhh",
			Header: "Stay Engaged with EHH",
			accessor: "bStayEngagedWithEhh",
			Cell: ({ original }) => (original.bStayEngagedWithEhh ? "Yes" : "No"),
		},

		{
			id: "bRequestedCallBack",
			Header: "Requested Call Back",
			accessor: "bRequestedCallBack",
			Cell: ({ original }) => (original.bRequestedCallBack ? "Yes" : "NA"),
		},
		{
			id: "bCouponApplied",
			Header: "Coupon Applied",
			accessor: "bCouponApplied",
			Cell: ({ original }) => (original.bCouponApplied ? "Yes" : "No"),
		},
		{
			id: "sCouponCode",
			Header: "Coupon Code",
			accessor: "sCouponCode"
		},
		{
			id: "fDiscountAmount",
			Header: "Coupon Discount Amount",
			accessor: "fDiscountAmount"
		},

	];
	return (
		<>
			<ReactTable
				data={props.data || []}
				columns={columns}
				manual
				pages={props.pages}
				page={props.page}
				pageSize={props.pageSize}
				//style={{height: "600px",overflow: "hidden"}}
				pageSizeOptions={[10,20,25,50,75,100]}
				onFetchData={(state, instance) => {
					props.onFetchServiceRequests(instance, true);
					// instance.state.pages = props.pages;
				}}
				// getTdProps={(state, rowInfo, column) => {
				//   if (column && column.id !== "checkbox") {
				//     return {
				//       onClick: e => props.onUserRowClick(rowInfo)
				//     };
				//   } else {
				//     return { onClick: (e, h) => h() };
				//   }
				// }}
				NextComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Next
					</Button>
				)}
				PreviousComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Previous
					</Button>
				)}
			/>
		</>
	);
}
